/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Line } from '@antv/g2plot';

import Frame from '../frame';
import Style from './style';
import Metrics from '../metrics';
import { mapData, Tooltip, DEFAULT_FILTER_VALUE, filtersConfig } from './helper';
import { useChartHelperDaily } from '../../../../../../../helpers/Charts';
import { getRange } from '../mitigation-actions-trend/helper';
import { useGeneralContext } from '../../../../../../../context/General';

const WeeklyProgress = ({
  data = null,
  t = (t) => t,
  valToResetFilters = null,
}) => {
  const container = useRef(null);
  const [graph, setGraph] = useState(null);
  const [activeFilter, setActiveFilter] = useState(DEFAULT_FILTER_VALUE);
  const [frameActions, setFrameActions] = useState(null);
  const { theme } = useGeneralContext();
  const [metricsValues, setMetricsValues] = useState([
    { color: "#FF4D4F", label: "Propsed Risk Mitigation", toggled: true },
    { color: "#1D39C4", label: "Assessed Mine Sites", toggled: true },
    { color: theme?.mmtPrimary7, label: "Identified Trade Relationships", toggled: true },
    { color: "#52C41A", label: "Completed Tasks", toggled: true },
  ]);
  const [filtersActions, setFiltersActions] = useState(null);

  const {
    getFilteredData,
    getFilteredColors,
    getActiveFilterData,
    initialConfig,
    setDaily,
    setMonthly,
    setWeekly,
  } = useChartHelperDaily({
    metricsValues,
    period: activeFilter,
    data,
    frameActions,
    t,
    graph,
    tooltTip: Tooltip,
  });

  useEffect(() => {
    if (data) {
      if (data.daily && data.monthly && data.weekly) {
        mapData({
          data,
          setDaily,
          setMonthly,
          setWeekly,
          keys: [
            'propsedRiskMitigation',
            'assessedMineSites',
            'identifiedTradeRelationships',
            'completedTasks',
          ],
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (!graph && metricsValues && getActiveFilterData) {
      const line = new Line(container.current, {
        data: getActiveFilterData || [],
        ...initialConfig(metricsValues),
        xAxis: {
          field: 'type',
        },
        yAxis: {
          tickMethod: (a) => getRange(a.max),
        },
        point: {
          size: 3,
          shape: 'circle',
          style: ({ series }) => ({
            fill: 'white',
            stroke: metricsValues.find((v) => v ? v.label === series : false).color,
          }),
        },
      });
      setGraph(line);
      line.render();
    } else if (graph && getActiveFilterData) {
      graph.update({
        data: getFilteredData(getActiveFilterData),
        color: getFilteredColors,
        animation: false,
        tooltip: {
          customContent: (_, data) => Tooltip(data, t),
        },
      });
    }
  }, [metricsValues, getActiveFilterData]);


  useEffect(() => {
    if (activeFilter !== DEFAULT_FILTER_VALUE) {
      setActiveFilter(DEFAULT_FILTER_VALUE);
      if (filtersActions && filtersActions.resetValue) {
        filtersActions.resetValue();
      }
    }
  }, [valToResetFilters]);

  const filters = {
    ...filtersConfig,
    onInit: (outActions) => setFiltersActions(outActions),
  };

  return <Frame
    title={t('Dashboard::Progress')}
    filters={filters}
    onFilterChange={(f) => setActiveFilter(f)}
    onInit={actions => setFrameActions(actions)}
  >
    <Style>
      <div className="progress-chart-container" ref={container} />
      {metricsValues && (
        <Metrics
          t={t}
          title={t('Dashboard::Key metrics')}
          metricsValues={metricsValues}
          setMetricsValues={setMetricsValues}
          isEmpty={false}
          metricGrid
        />
      )}
    </Style>
  </Frame>;
}

export default WeeklyProgress;
